import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-lg flex-col items-center justify-center px-5 text-center">
      <XCircle className="text-zinc-500" size={56} />
      <h1 className="mt-6 font-display text-2xl font-800 text-white">Checkout cancelled</h1>
      <p className="mt-2 text-zinc-500">No worries — your cart is still saved.</p>
      <Link to="/cart" data-testid="cancel-back-cart" className="mt-8 rounded-full bg-primary px-7 py-3.5 font-medium text-white transition-transform hover:-translate-y-1">Return to cart</Link>
    </div>
  );
}
